module.exports = {"Title Page":"Кейсы","Header Page":"Управление кейсами","Filter":"Фильтр","Table":"Таблица"};